export enum ExpoBagPage {
	Menu = 'menu',
	Checkout = 'checkout',
	Order = 'order',
}